<template>
  <div class="view-root">
    <div v-show="showQuery" class="container">
      <table>
        <tbody>
          <tr>
            <th colspan="4">検索条件</th>
          </tr>
          <tr>
            <td>課題名および内容</td>
            <td colspan="3">
              <input type="text" id="keyword" v-model="keyword" />
              <table class="insidetable">
                <tbody>
                  <tr class="insidetr">
                    <td class="insidetd">
                      <b-form-checkbox
                        id="targetMainTitle"
                        v-model="targetMainTitle"
                        value="true"
                        unchecked-value="false"
                      >
                        研究課題名から検索
                      </b-form-checkbox>
                    </td>
                    <td class="insidetd">
                      <b-form-checkbox
                        id="targetPartTitle"
                        v-model="targetPartTitle"
                        value="true"
                        unchecked-value="false"
                      >
                        分担研究課題名から検索
                      </b-form-checkbox>
                    </td>
                    <td class="insidetd">
                      <b-form-checkbox
                        id="targetReport"
                        v-model="targetReport"
                        value="true"
                        unchecked-value="false"
                      >
                        報告書から検索
                      </b-form-checkbox>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>実施期間</td>
            <td colspan="3">
              <b-form-checkbox
                id="restrictDuration"
                v-model="restrictDuration"
                value="applied"
                unchecked-value="not_applied"
                @input="changeDurationRestriction"
              >
                期間指定を行う
              </b-form-checkbox>
              <span v-show="showDuration">
                <input
                  type="number"
                  min="2006"
                  class="nendo"
                  id="start"
                  v-model="start"
                />
                年度から
                <input
                  type="number"
                  min="2006"
                  class="nendo"
                  id="end"
                  v-model="end"
                />
                年度まで
              </span>
            </td>
          </tr>
          <tr>
            <td>研究者名</td>
            <td>
              <input type="text" id="researcherName" v-model="researcherName" />
            </td>
            <td>
              <b-form-checkbox
                id="targetMainName"
                v-model="targetMainName"
                value="true"
                unchecked-value="false"
              >
                代表研究者名から検索
              </b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox
                id="targetPartName"
                v-model="targetPartName"
                value="true"
                unchecked-value="false"
              >
                分担研究者名から検索
              </b-form-checkbox>
            </td>
          </tr>
          <tr>
            <td>所属施設</td>
            <td>
              <input type="text" id="affiliation" v-model="affiliation" />
            </td>
            <td>
              <b-form-checkbox
                id="targetMainAffiliation"
                v-model="targetMainAffiliation"
                value="true"
                unchecked-value="false"
              >
                代表研究者所属から検索
              </b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox
                id="targetPartAffiliation"
                v-model="targetPartAffiliation"
                value="true"
                unchecked-value="false"
              >
                分担研究者所属から検索
              </b-form-checkbox>
            </td>
          </tr>
          <tr hidden>
            <td>
              <b-form-checkbox
                id="needsReports"
                v-model="needsReports"
                value="true"
                unchecked-value="false"
              >
                報告書がある課題に絞る
              </b-form-checkbox>
            </td>
            <td colspan="3"></td>
          </tr>
        </tbody>
      </table>
      <a href="#" class="btn-flat-border" @click="search">検索</a>
    </div>
    <div v-show="showSearchWaiting">
      <button class="btn-flat-border" type="button" disabled>
        <span
          class="spinner-grow spinner-grow-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Searching...
      </button>
    </div>
    <div v-show="showSearchResultJson">{{ searchResult }}</div>
    <div v-show="showSearchResult" class="container">
      <b-table
        id="search-result-table"
        :fields="searchResultFields"
        :items="searchResultList"
        :per-page="perPage"
        :current-page="currentPage"
        small
        fixed
        class="btable"
      >
        <template #table-colgroup="data">
          <col
            v-for="field in data.fields"
            :key="field.key"
            :style="{
              width:
                field.key === 'kName'
                  ? '25%'
                  : field.key === 'kNo'
                  ? '10%'
                  : field.key === 'kNendo'
                  ? '10%'
                  : field.key === 'kDaihyoshaName'
                  ? '10%'
                  : field.key === 'kDaihyoshaShozoku'
                  ? '25%'
                  : field.key === 'kYearHokokusho'
                  ? '10%'
                  : field.key === 'kFinalHokokusho'
                  ? '10%'
                  : '10%',
            }"
          />
        </template>
        <template #cell(kName)="data">
          <a href="#" @click="eachgetter(data.item.kadaiId)">{{
            data.item.kadaiName
          }}</a>
        </template>
        <template #cell(kNo)="data">
          {{ data.item.kadaiNo }}
        </template>
        <template #cell(kNendo)="data">
          {{ data.item.nendo }}
        </template>
        <template #cell(kDaihyoshaName)="data">
          {{ data.item.daihyoshaName }}
        </template>
        <template #cell(kDaihyoshaShozoku)="data">
          {{ data.item.daihyoshaShozoku }}
        </template>
        <template #cell(kYearHokokusho)="data">
          <a
            v-bind:href="data.item.yearHokokusho"
            target="_blank"
            rel="noopener noreferrer"
            v-show="data.item.yearHokokushoExists"
            >PDF</a
          >
        </template>
        <template #cell(kFinalHokokusho)="data">
          <a
            v-bind:href="data.item.finalHokokusho"
            target="_blank"
            rel="noopener noreferrer"
            v-show="data.item.finalHokokushoExists"
            >PDF</a
          >
        </template>
      </b-table>
      <div class="customPagination">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          :limit="7"
          aria-controls="search-result-table"
          align="right"
        ></b-pagination>
      </div>
    </div>
    <div v-show="showDetailJson">{{ eachText }}</div>
    <div v-show="showDetail" class="container">
      <table>
        <tbody>
          <tr>
            <th colspan="2">基本情報</th>
          </tr>
          <tr>
            <td class="w20">研究課題名</td>
            <td>{{ eachKadaiName }}</td>
          </tr>
          <tr>
            <td>研究事業名</td>
            <td>{{ eachJigyoName }}</td>
          </tr>
          <tr>
            <td>課題番号</td>
            <td>{{ eachKadaiNo }}</td>
          </tr>
          <tr>
            <td>研究年度</td>
            <td>{{ eachNendo }}</td>
          </tr>
          <tr>
            <td>代表</td>
            <td>{{ eachDaihyoshaName }}</td>
          </tr>
          <tr>
            <td>所属施設</td>
            <td>{{ eachDaihyoshaShozoku }}</td>
          </tr>
          <tr>
            <td>経過研究年</td>
            <td>{{ eachKeikaYear }}</td>
          </tr>
          <!--
          <tr>
            <td>研究カテゴリ</td>
            <td>{{ eachKenkyuCategory }}</td>
          </tr>
          -->
          <tr>
            <td>合計研究年</td>
            <td>{{ eachTotalKenkyuYear }}</td>
          </tr>
          <!--
          <tr>
            <td>研究終了予定日</td>
            <td>{{ eachEndDate }}</td>
          </tr>
          -->
          <tr>
            <td>研究分野名</td>
            <td>{{ eachKenkyuBunya }}</td>
          </tr>
          <!--
          <tr>
            <td>研究区分名</td>
            <td>{{ eachKenkyuKubun }}</td>
          </tr>
          <tr>
            <td>疫学・生物統計学関与</td>
            <td>{{ eachStatisticsRelation }}</td>
          </tr>
          <tr>
            <td>臨床研究登録予定</td>
            <td>{{ eachClinicalRegistry }}</td>
          </tr>
          -->
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th class="w10">役割</th>
            <th class="w10">研究者名</th>
            <th class="w40">
              所属施設<br />
              職名
            </th>
            <th class="w40">分担課題名</th>
          </tr>
          <tr v-for="(item, index) in researcherList" :key="index">
            <td>{{ item.yakuwari }}</td>
            <td>{{ item.researcherName }}</td>
            <td>
              {{ item.researcherShozoku }}<br />
              {{ item.researcherPosition }}
            </td>
            <td>{{ item.buntanKadaiName }}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th class="w20">報告書種別</th>
            <th class="w10">研究者名</th>
            <th class="w60">所属施設</th>
            <th class="w10">報告書</th>
          </tr>
          <tr v-for="(item, index) in hokokushoList" :key="index">
            <td>{{ item.hokokushoShubetsu }}</td>
            <td>{{ item.firstResearcherName }}</td>
            <td>{{ item.firstResearcherShozoku }}</td>
            <td>
              <a
                v-bind:href="item.hokokushoPdfUrl"
                target="_blank"
                rel="noopener noreferrer"
                >PDF</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <a href="#" class="btn-flat-border" @click="goList">一覧画面に戻る</a>
    </div>
    <p>{{ message1 }}{{ message2 }}</p>
  </div>
</template>

<script>
import Repository from "../infrastructure/Repository.ts";

export default {
  data: function () {
    return {
      showQuery: true,
      showSearchWaiting: false,
      showSearchResultJson: false,
      showSearchResult: false,
      showDetailJson: false,
      showDetail: false,
      keyword: "",
      targetMainTitle: true,
      targetPartTitle: true,
      targetReport: false,
      restrictDuration: "not_applied",
      showDuration: false,
      start: 2021,
      end: 2021,
      startStr: "",
      endStr: "",
      needsReports: false,
      researcherName: "",
      targetMainName: true,
      targetPartName: true,
      affiliation: "",
      targetMainAffiliation: true,
      targetPartAffiliation: true,
      searchResult: "",
      perPage: 20,
      currentPage: 1,
      searchResultFields: [
        { key: "kName", label: "研究課題名" },
        { key: "kNo", label: "課題番号" },
        { key: "kNendo", label: "年度" },
        { key: "kDaihyoshaName", label: "代表" },
        { key: "kDaihyoshaShozoku", label: "所属施設" },
        { key: "kYearHokokusho", label: "年度報告書" },
        { key: "kFinalHokokusho", label: "最終報告書" },
      ],
      searchResultList: [],
      researchId: "",
      eachText: "",
      eachKadaiName: "",
      eachJigyoName: "",
      eachKadaiNo: "",
      eachNendo: "",
      eachDaihyoshaName: "",
      eachDaihyoshaShozoku: "",
      eachKeikaYear: "",
      eachKenkyuCategory: "",
      eachTotalKenkyuYear: "",
      eachEndDate: "",
      eachKenkyuBunya: "",
      eachKenkyuKubun: "",
      eachStatisticsRelation: "",
      eachClinicalRegistry: "",
      researcherList: [],
      hokokushoList: [],
      message1: "",
      message2: "",
    };
  },
  methods: {
    changeDurationRestriction() {
      this.showDuration = !this.showDuration;
    },
    async search() {
      this.searchResult = "wait a moment";
      this.showSearchWaiting = true;
      this.startStr = "";
      this.endStr = "";
      if (this.restrictDuration == "applied") {
        if (this.start <= this.end) {
          if (this.start) this.startStr = this.start.toString() + "-04-01";
          if (this.end) this.endStr = this.end.toString() + "-04-01";
        } else {
          if (this.start) this.endStr = this.start.toString() + "-04-01";
          if (this.end) this.startStr = this.end.toString() + "-04-01";
        }
      }
      var jsonStr = await new Repository().search(
        this.keyword,
        this.targetMainTitle,
        this.targetPartTitle,
        this.targetReport,
        this.startStr,
        this.endStr,
        this.needsReports,
        this.researcherName,
        this.targetMainName,
        this.targetPartName,
        this.affiliation,
        this.targetMainAffiliation,
        this.targetPartAffiliation
      );
      this.searchResult = jsonStr.data;
      this.searchResultList.splice(0, this.searchResultList.length);
      jsonStr.data.forEach((element) => {
        this.searchResultList.push({
          kadaiId: element.kadai_id,
          kadaiName: element.kadai_name,
          kadaiNo: element.kadai_no,
          nendo: element.nendo,
          daihyoshaName: element.daihyosha_name,
          daihyoshaShozoku: element.daihyosha_shozoku,
          hokokushoList: element.hokokushoList,
          yearHokokushoExists: false,
          finalHokokushoExists: false,
        });
        console.log(element.hokokushoList);
      });
      for (let itemNo = 0; itemNo < this.searchResultList.length; itemNo++) {
        this.searchResultList[itemNo].nendo =
          this.searchResultList[itemNo].nendo.substr(0, 4) + "年度";

        this.searchResultList[itemNo].hokokushoList.forEach((element) => {
          if (element.hokokusho_shubetsu == "年度報告書") {
            this.searchResultList[itemNo].yearHokokusho =
              element.hokokusho_pdf_url;
            this.searchResultList[itemNo].yearHokokushoExists = true;
          } else if (element.hokokusho_shubetsu == "最終（総括）報告書") {
            this.searchResultList[itemNo].finalHokokusho =
              element.hokokusho_pdf_url;
            this.searchResultList[itemNo].finalHokokushoExists = true;
          }
        });
      }
      this.showSearchWaiting = false;
      this.currentPage = 1;
      this.showSearchResult = true;
    },
    async eachgetter(researchId) {
      this.eachText = "wait a moment";

      var jsonStr = await new Repository().getEach(researchId);

      this.eachText = jsonStr.data;
      this.eachKadaiName = jsonStr.data.kadai_name;
      this.eachJigyoName = jsonStr.data.jigyo_name;
      this.eachKadaiNo = jsonStr.data.kadai_no;
      this.eachNendo = jsonStr.data.nendo.substr(0, 4) + "年度";
      this.eachDaihyoshaName = jsonStr.data.daihyosha_name;
      this.eachDaihyoshaShozoku = jsonStr.data.daihyosha_shozoku;
      this.eachKeikaYear = jsonStr.data.keika_year.toString();
      if (this.eachKeikaYear == "-1") {
        this.eachKeikaYear = "";
      }
      this.eachKenkyuCategory = jsonStr.data.kenkyu_category;
      this.eachTotalKenkyuYear = jsonStr.data.total_kenkyu_year.toString();
      if (this.eachTotalKenkyuYear == "-1") {
        this.eachTotalKenkyuYear = "";
      }
      this.eachEndDate = jsonStr.data.end_date.substr(0, 10);
      if (this.eachEndDate == "0001-01-01") {
        this.eachEndDate = "";
      }
      this.eachKenkyuBunya = jsonStr.data.kenkyu_bunya;
      this.eachKenkyuKubun = jsonStr.data.kenkyu_kubun;

      if (jsonStr.data.statistics_relation) this.eachStatisticsRelation = "有";
      else this.eachStatisticsRelation = "無";

      if (jsonStr.data.clinical_registry) this.eachClinicalRegistry = "有";
      else this.eachClinicalRegistry = "無";

      this.researcherList.splice(0, this.researcherList.length);
      jsonStr.data.kenkyuResearcherRelations.forEach((element) => {
        this.researcherList.push({
          yakuwari: element.yakuwari,
          researcherName: element.researcher_name,
          researcherShozoku: element.researcher_shozoku,
          researcherPosition: element.researcher_position,
          buntanKadaiName: element.buntan_kadai_name,
        });
      });

      this.hokokushoList.splice(0, this.hokokushoList.length);
      jsonStr.data.hokokushoList.forEach((element) => {
        if (
          element.hokokusho_shubetsu == "年度報告書" ||
          element.hokokusho_shubetsu == "最終（総括）報告書"
        ) {
          this.hokokushoList.push({
            hokokushoShubetsu: element.hokokusho_shubetsu,
            firstResearcherName: element.first_researcher_name,
            firstResearcherShozoku: element.first_researcher_shozoku,
            hokokushoPdfUrl: element.hokokusho_pdf_url,
          });
        }
      });

      this.showQuery = false;
      this.showSearchResult = false;
      this.showDetail = true;
    },
    goList() {
      this.showDetail = false;
      this.showQuery = true;
      this.showSearchResult = true;
    },
  },
  computed: {
    rows() {
      return this.searchResultList.length;
    },
  },
  mounted: function () {
    this.$nextTick(function () {
      document.getElementById("keyword").focus();
    });
  },
};
</script>

<style>
body {
  background-color: #fafafa;
}

.custom-checkbox
  > .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #005ead;
}

input[type="number"].nendo {
  width: 70px;
}

.btn-flat-border {
  display: inline-block;
  margin-bottom: 1em;
  padding: 0.3em 1em;
  text-decoration: none;
  background-color: #f0f0f0;
  border: solid 2px #005ead;
  border-radius: 3px;
  transition: 0.4s;
}

.btn-flat-border:hover {
  background: #005ead;
  color: white;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-top: 10px;
  margin-right: auto;
  margin-bottom: 10px;
  margin-left: auto;
  border: groove 1px #ffffff;
}

table.insidetable {
  margin: 0px;
  padding: 0px;
  border: none;
}

table tr:nth-child(even) {
  background-color: #ffffff;
}

table tr:nth-child(odd) {
  background-color: #f0f0fd;
}

table tr.insidetr {
  margin: 0px;
  padding: 0px;
  background-color: #ffffff;
}

table.btable tr:nth-child(even) {
  background-color: #f0f0fd;
}

table.btable tr:nth-child(odd) {
  background-color: #ffffff;
}

table th {
  background-color: #005ead;
  color: #ffffff;
}

table th,
table td {
  padding: 10px 5px;
  text-align: left;
  vertical-align: middle;
  font-family: "メイリオ", "Meiryo", sans-serif;
}

table td.insidetd {
  padding-bottom: 0px;
}

table th.w60,
table td.w60 {
  width: 60%;
}

table th.w40,
table td.w40 {
  width: 40%;
}

table th.w20,
table td.w20 {
  width: 20%;
}

table th.w10,
table td.w10 {
  width: 10%;
}

a {
  color: #005ead;
  transition: color 0.3s;
}

a:visited {
  color: #005ead;
}

a:hover {
  color: #ff7043;
}

a:active {
  color: #26a69a;
}

div.customPagination > ul > li > button {
  color: #005ead;
}
</style>
